import { useRef, useState } from 'react';

import {
    Box,
    List,
    ListItem,
    Divider,
    Typography,
    ListItemText,
    Popover,
    Card,
    CardContent,
    Button,
} from '@mui/material';

import internationalization from 'src/i18n/i18n';
import { useTranslation } from 'react-i18next';
import { US, ES } from 'country-flag-icons/react/3x2';
import UnfoldMoreTwoToneIcon from "@mui/icons-material/UnfoldMoreTwoTone";

function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const { t }: { t: any } = useTranslation();
    const getLanguage = i18n.language;

    const switchLanguage = ({ lng }: { lng: any }) => {
        internationalization.changeLanguage(lng);
        localStorage.setItem('language', lng);
    };
    const ref = useRef<any>(null);
    const [isOpen, setOpen] = useState<boolean>(false);

    const handleOpen = (): void => {
        setOpen(true);
    };

    const handleClose = (): void => {
        setOpen(false);
    };

    return (
        <>
            <Card>
                <Box
                    p={3}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Box>
                        <Typography variant="h4" gutterBottom>
                            {t('LANGUAGE_SWITCHER.HEADING')}
                        </Typography>
                        <Typography variant="subtitle2">
                            {t('LANGUAGE_SWITCHER.SUBHEADING')}
                        </Typography>
                    </Box>
                </Box>
                <Divider />
                <CardContent
                    sx={{
                        p: 4
                    }}
                >

                    <Button
                        fullWidth
                        size="large"
                        variant="outlined"
                        color="primary"
                        aria-haspopup="true"
                        aria-expanded={isOpen ? "true" : undefined}
                        onClick={handleOpen}
                        ref={ref}
                        endIcon={<UnfoldMoreTwoToneIcon />}
                    >
                        {getLanguage === 'en' && 'English'}
                        {getLanguage === 'es' && 'Español'}
                    </Button>
                    <Popover
                        disableScrollLock
                        anchorEl={ref.current}
                        onClose={handleClose}
                        open={isOpen}
                        anchorOrigin={{
                            vertical: "center",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "center",
                            horizontal: "center",
                        }}
                    >
                        <Box
                            sx={{
                                maxWidth: 240
                            }}
                        >
                            <List
                                sx={{
                                    p: 2
                                }}
                                component="nav"
                            >
                                <ListItem
                                    className={
                                        getLanguage === 'en' || getLanguage === 'en-US' ? 'active' : ''
                                    }
                                    button
                                    onClick={() => {
                                        switchLanguage({ lng: 'en' });
                                        handleClose();
                                    }}
                                >
                                    <US title='English' />
                                    <ListItemText
                                        sx={{
                                            pl: 1,
                                            mr: 3
                                        }}
                                        primary="English"
                                    />
                                </ListItem>
                                <ListItem
                                    className={getLanguage === 'es' ? 'active' : ''}
                                    button
                                    onClick={() => {
                                        switchLanguage({ lng: 'es' });
                                        handleClose();
                                    }}
                                >
                                    <ES title='Spanish' />
                                    <ListItemText
                                        sx={{
                                            pl: 1,
                                            mr: 3
                                        }}
                                        primary="Spanish"
                                    />
                                </ListItem>
                            </List>
                        </Box>
                    </Popover>
                </CardContent>
            </Card>
        </>
    );
}

export default LanguageSwitcher;
